/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * position object
 * @export
 * @interface GetUniverseStargatesStargateIdPosition
 */
export interface GetUniverseStargatesStargateIdPosition {
    /**
     * x number
     * @type {number}
     * @memberof GetUniverseStargatesStargateIdPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof GetUniverseStargatesStargateIdPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof GetUniverseStargatesStargateIdPosition
     */
    z: number;
}

/**
 * Check if a given object implements the GetUniverseStargatesStargateIdPosition interface.
 */
export function instanceOfGetUniverseStargatesStargateIdPosition(value: object): value is GetUniverseStargatesStargateIdPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function GetUniverseStargatesStargateIdPositionFromJSON(json: any): GetUniverseStargatesStargateIdPosition {
    return GetUniverseStargatesStargateIdPositionFromJSONTyped(json, false);
}

export function GetUniverseStargatesStargateIdPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseStargatesStargateIdPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function GetUniverseStargatesStargateIdPositionToJSON(json: any): GetUniverseStargatesStargateIdPosition {
    return GetUniverseStargatesStargateIdPositionToJSONTyped(json, false);
}

export function GetUniverseStargatesStargateIdPositionToJSONTyped(value?: GetUniverseStargatesStargateIdPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

